interface VenueMapSectionProps {
  venueName: string;
  address: string;
  district: string;
  lat: number;
  lng: number;
}

export default function VenueMapSection({
  venueName,
  address,
  district,
  lat,
  lng,
}: VenueMapSectionProps) {
  const embedUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY&q=${lat},${lng}&zoom=16`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  const mapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;

  return (
    <section className="mb-12">
      <h2 className="text-xl font-bold text-stone-800 mb-5">Konumu Görüntüle</h2>

      <div className="relative rounded-2xl overflow-hidden border border-stone-100" style={{ height: "440px" }}>
        {/* Map iframe */}
        <iframe
          title={`${venueName} Konum Haritası`}
          src={embedUrl}
          className="w-full h-full border-0"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />

        {/* Overlay: venue info card (bottom-left) */}
        <div className="absolute bottom-4 left-4 right-4 md:right-auto md:max-w-xs bg-white rounded-xl p-4 z-10">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-emerald-100 rounded-lg mt-0.5">
              <i className="ri-map-pin-2-fill text-emerald-700 text-lg" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold text-stone-800 text-sm leading-tight truncate">{venueName}</p>
              <p className="text-stone-500 text-xs mt-0.5 leading-relaxed line-clamp-2">{address}</p>
              <p className="text-stone-400 text-xs mt-1">{district}, Bursa</p>
            </div>
          </div>

          <div className="flex gap-2 mt-3">
            <a
              href={directionsUrl}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex-1 flex items-center justify-center gap-1.5 bg-emerald-700 hover:bg-emerald-800 text-white rounded-lg py-2 text-xs font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-navigation-line text-sm" />
              Yol Tarifi
            </a>
            <a
              href={mapsUrl}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex-1 flex items-center justify-center gap-1.5 border border-stone-200 text-stone-700 hover:bg-stone-50 rounded-lg py-2 text-xs font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line text-sm" />
              Haritada Aç
            </a>
          </div>
        </div>

        {/* Koordinat badge (top-right) */}
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-1.5 text-xs text-stone-500 font-mono">
          {lat.toFixed(5)}, {lng.toFixed(5)}
        </div>
      </div>
    </section>
  );
}
